import { api } from "./api";

const expenseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getExpense: builder.query({
      query: () => "/expense",
      providesTags: ["expense"],
    }),
    addExpense: builder.mutation({
      query: (newData) => ({
        url: "/expense",
        method: "POST",
        body: newData,
      }),
      invalidatesTags: ["expense"],
    }),
    removeExpense: builder.mutation({
      query: (id) => ({
        url: `/expense/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["expense"],
    }),
    editExpense: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/expense/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["expense"],
    }),
  }),
});

export const {
  useGetExpenseQuery,
  useAddExpenseMutation,
  useRemoveExpenseMutation,
  useEditExpenseMutation,
} = expenseApi;
